export const activate_by = {
    load: 'Актывацыя',
    positiveResponse: 'Актывацыя прайшла паспяхова',
    negativeResponse: 'Нешта пайшло не так',
    repeatRequest: 'Вы ўжо зарэгістраваныя',
    linkMainPage: 'Галоўная старонка',
    login: 'Уваход',
}